import PropTypes from 'prop-types';
import React from 'react';
import BaseToolTip from 'common/Workqueue/BaseToolTip';

export default function EditSADisabledToolTip({
  children,
  disabled,
  position,
}) {
  return (
    <BaseToolTip
      condition={disabled}
      position={position}
      text="A request to change this authorization has already been submitted."
    >
      {children}
    </BaseToolTip>
  );
}

EditSADisabledToolTip.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool.isRequired,
  position: PropTypes.oneOf([
    'top',
    'top-start',
    'top-end',
    'right',
    'bottom',
    'bottom-start',
    'bottom-end',
    'left',
  ]),
};

EditSADisabledToolTip.defaultProps = {
  position: undefined,
};
